import { Box, Grid, InputLabel, TextField } from "@mui/material";
import { FC, Fragment, useState } from "react";
import useMutation from "../../../../shared/components/hooks/useMutation";
import { getTextFields } from "../variables/getTextFields";
import { useFormik } from "formik";
import { customizeValidationSchema } from "../variables/customSchema";
import { FormContainer } from "../../../../shared/components/formContainer";
import ToggleSwitch from "../../../../shared/components/switch";
import InputTextfield from "../../../../shared/components/textField";
import SingleEntityImageViewer from "../../../../shared/components/singleEntityImageViewer";
import { ProfileBorderBox } from "../../../../shared/components/profileComponents";

const ServiceCreate: FC = () => {
  const { loading: apiLoading, modifyData } = useMutation("/services");
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const textFields = getTextFields({});

  const initialValues = {
    name: "",
    iconURL: null,
    enabled: true,
    description: "",
  };

  const servicesForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: customizeValidationSchema(),
    onSubmit: async (formData: any) => {
      const servicesFormData = new FormData();
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      servicesFormData.append("file", formData.iconURL);
      servicesFormData.append("name", formData.name);
      servicesFormData.append("description", formData.description);
      servicesFormData.append("enabled", formData.enabled ? "true" : "false");

      const response = await modifyData(
        `/services`,
        "post",
        servicesFormData,
        servicesForm
      );
    },
  });

  console.log(servicesForm);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setPreviewUrl(URL.createObjectURL(file));
      servicesForm.setFieldValue("iconURL", file);
    } else {
      setPreviewUrl(null);
      servicesForm.setFieldValue("iconURL", null);
    }
  };

  const titleBar = {
    headerTitle: "Services - Create",
    title: "Create Service",
    buttonTitle: "Save",
    onClick: () => servicesForm.handleSubmit(),
    dirty: servicesForm.dirty,
    buttonLoading: apiLoading,
  };

  return (
    <>
      <ProfileBorderBox>
        <FormContainer titleBar={titleBar}>
          <Box className="border-custom">
            <Grid
              container
              alignItems="stretch"
              columnSpacing={4}
              rowSpacing={2}
            >
              <Grid item xs={12}>
                <ToggleSwitch
                  status={servicesForm?.values?.enabled}
                  handleChange={() =>
                    servicesForm.setFieldValue(
                      "enabled",
                      !servicesForm?.values?.enabled
                    )
                  }
                />
              </Grid>

              {textFields.map((field: any, index: number) => (
                <Fragment key={field.id}>
                  {(field?.formField === undefined ||
                    field.formField === true) && (
                    <Grid item md={6} sm={6} xs={12}>
                      <InputTextfield
                        form={servicesForm}
                        fieldProps={field}
                        key={index}
                      />
                    </Grid>
                  )}
                </Fragment>
              ))}
              <Grid item md={6} sm={6} xs={6} key="services-iconURL">
                <InputLabel>Icon</InputLabel>
                <TextField
                  size="small"
                  fullWidth
                  id="outlined-basic"
                  type={"file"}
                  sx={{
                    marginTop: "1vh",
                    "& .MuiInputBase-root": {
                      height: "40px",
                      fontSize: "1rem",
                    },
                  }}
                  onChange={handleFileChange}
                />
              </Grid>
              <Grid item md={3} sm={6} xs={6} key="services-iconPreview">
                <div>
                  <SingleEntityImageViewer src={previewUrl} alt="Event" />
                </div>
              </Grid>
            </Grid>
          </Box>
        </FormContainer>
      </ProfileBorderBox>
    </>
  );
};

export default ServiceCreate;
